webpackJsonp([79],{

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1249);


/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(171);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(777);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1248]);


// WEBPACK FOOTER //
// app/datetime.en-103c127e9699c36c7753.js